import { render, staticRenderFns } from "./ModalBinderAudit.vue?vue&type=template&id=6f2d64a8&"
import script from "./ModalBinderAudit.vue?vue&type=script&lang=js&"
export * from "./ModalBinderAudit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports